<template>
    <div v-html="html"></div>
</template>

<script>
const styleOrEmpty = (value, name) => (value ? `${name}:${value};` : '');

export const buildDefaultHtml = (props = {}) => {
    const title = props.title || '';
    const content = props.content || '';
    const backgroundColor = styleOrEmpty(props.backgroundColor, 'background-color');
    const border = styleOrEmpty(props.border, 'border');
    const borderRadius = styleOrEmpty(props.borderRadius, 'border-radius');
    const padding = styleOrEmpty(props.padding, 'padding');
    const align = styleOrEmpty(props.align, 'text-align');
    const titleColor = styleOrEmpty(props.titleColor, 'color');
    const titleSize = styleOrEmpty(props.titleSize, 'font-size');
    const titleFamily = styleOrEmpty(props.titleFamily, 'font-family');
    const titleWeight = styleOrEmpty(props.titleWeight, 'font-weight');
    const titleMargin = styleOrEmpty(props.titleMargin, 'margin');
    const bodyColor = styleOrEmpty(props.bodyColor, 'color');
    const bodySize = styleOrEmpty(props.bodySize, 'font-size');
    const bodyFamily = styleOrEmpty(props.bodyFamily, 'font-family');
    const bodyLineHeight = styleOrEmpty(props.bodyLineHeight, 'line-height');
    const bodyMargin = styleOrEmpty(props.bodyMargin, 'margin');

    return `<article style="margin:0;${backgroundColor}${border}${borderRadius}${padding}${align}">
        <h3 style="margin:0;${titleColor}${titleSize}${titleFamily}${titleWeight}${titleMargin}">${title}</h3>
        <p style="margin:0;${bodyColor}${bodySize}${bodyFamily}${bodyLineHeight}${bodyMargin}">${content}</p>
    </article>`;
};

export default {
    name: 'MailingBlockArticle',
    props: {
        html: { type: String, default: '' },
    },
};
</script>
